import PropTypes from 'prop-types'
import { Switch, Redirect } from 'react-router'

import ManageBrandsLayout from '@src/components/brands/ManageBrandsLayout'
import manageBrandsPaths from '@src/components/brands/manageBrandsPaths'
import Calendar from '@src/components/calendar/Calendar'
import calendarPaths from '@src/components/calendar/calendarPaths'
import CampaignContentPage from '@src/components/content/CampaignContentPage'
import campaignContentPaths, {
  legacyCampaignContentPaths,
} from '@src/components/content/campaignContentPaths'
import IndustryContentPage from '@src/components/content/IndustryContentPage'
import industryContentPaths from '@src/components/content/industryContentPaths'
import Downloadables from '@src/components/downloadables/Downloadables'
import downloadablesPaths from '@src/components/downloadables/downloadablesPaths'
import EmbeddedSearch from '@src/components/embeddedSmartSearch/EmbeddedSearch'
import embeddedSearchPaths from '@src/components/embeddedSmartSearch/embeddedSearchPaths'
import LeadImport from '@src/components/leads/LeadImport'
import leadsPaths from '@src/components/leads/leadPaths'
import Leads from '@src/components/leads/Leads'
import ReportingDetailsOrganic from '@src/components/reporting/OrganicCampaignDetails'
import Reporting from '@src/components/reporting/Reporting/Reporting.tsx'
import reportingPaths, {
  legacyReportingPaths,
} from '@src/components/reporting/reportingPaths'
import { FacebookPermissionsManagerPage } from '@src/components/routes/authenticated/FacebookPermissionsManagerPage'
import { IGAutomationPage } from '@src/components/routes/authenticated/IGAutomationPage'
import { IGDesktopSetupPage } from '@src/components/routes/authenticated/IGDesktopSetupPage'
import { ManageBrandPage } from '@src/components/routes/authenticated/ManageBrandPage'
import FullNav from '@src/components/shared/FullNav'
import JwtHandler from '@src/components/shared/JwtHandler'
import RetailerAccountSelectorHandler from '@src/components/shared/RetailerAccountSelectorHandler'

import OrganicCampaignDetailsLayout from '../content/organicCampaignDetails/OrganicCampaignDetailsLayout'
import organicCampaignPaths from '../content/organicCampaignPaths'
import RetailerSettingsLayout from '../retailerSettings/RetailerSettingsLayout'
import retailerSettingsPaths from '../retailerSettings/retailerSettingsPaths'

import CommonRoute from './CommonRoute'
import LegacyBrandRoutesHandler from './LegacyBrandRoutesHandler'

export const MainNavRoutes = (props) => {
  return (
    <JwtHandler>
      <Switch>
        <CommonRoute
          path={'/retailer/facebook-permissions-manager/:retailerAccountSlug'}
          render={(props) => {
            return (
              <RetailerAccountSelectorHandler>
                <FacebookPermissionsManagerPage {...props} />
              </RetailerAccountSelectorHandler>
            )
          }}
        />
        <CommonRoute
          path={'/retailer/ig-automation/:retailerAccountSlug/:retailerSlug'}
          render={(props) => {
            return (
              <RetailerAccountSelectorHandler>
                <IGAutomationPage {...props} />
              </RetailerAccountSelectorHandler>
            )
          }}
        />
        <CommonRoute
          path={'/retailer/ig-desktop-setup/:retailerAccountSlug'}
          render={(props) => {
            return (
              <RetailerAccountSelectorHandler>
                <IGDesktopSetupPage {...props} />
              </RetailerAccountSelectorHandler>
            )
          }}
        />
        <CommonRoute
          path={'/retailer/manage-brand/:retailerAccountSlug/:retailerSlug'}
          render={(props) => {
            return (
              <RetailerAccountSelectorHandler>
                <ManageBrandPage {...props} />
              </RetailerAccountSelectorHandler>
            )
          }}
        />

        <CommonRoute
          path={campaignContentPaths.index.path}
          render={(props) => {
            return (
              <RetailerAccountSelectorHandler>
                <FullNav>
                  <CampaignContentPage {...props} />
                </FullNav>
              </RetailerAccountSelectorHandler>
            )
          }}
        />

        <CommonRoute
          path={legacyCampaignContentPaths.index.path}
          redirectPath={(match) =>
            `/#/${match.params.retailerAccountSlug}/${match.params.brandSlug}/content`
          }
          render={(props) => {
            return <LegacyBrandRoutesHandler {...props} />
          }}
        />

        <CommonRoute
          canAccess={props.isNewReportingEnabled}
          path={reportingPaths.organicCampaignDetails.path}
          redirectPath={(match) =>
            `/#/${match.params.retailerAccountSlug}/${match.params.brandSlug}/reporting/list`
          }
          render={(props) => {
            return (
              <RetailerAccountSelectorHandler>
                <FullNav backgroundColor="transparent">
                  <ReportingDetailsOrganic {...props} />
                </FullNav>
              </RetailerAccountSelectorHandler>
            )
          }}
        />

        <CommonRoute
          canAccess={props.isNewReportingEnabled}
          path={reportingPaths.index.path}
          render={(props) => {
            return (
              <RetailerAccountSelectorHandler>
                <FullNav backgroundColor="transparent">
                  <Reporting {...props} />
                </FullNav>
              </RetailerAccountSelectorHandler>
            )
          }}
        />

        <CommonRoute
          canAccess={props.isNewReportingEnabled}
          path={legacyReportingPaths.index.path}
          exact
          render={(props) => <LegacyBrandRoutesHandler {...props} />}
        />

        <CommonRoute
          path={downloadablesPaths.index.path}
          render={(props) => {
            return props.match.params.brandSlug !== 'all' ? (
              <LegacyBrandRoutesHandler {...props} />
            ) : (
              <RetailerAccountSelectorHandler>
                <FullNav>
                  <Downloadables {...props} />
                </FullNav>
              </RetailerAccountSelectorHandler>
            )
          }}
        />
        <CommonRoute
          path={manageBrandsPaths.index.path}
          render={(props) => {
            return props.match.params.brandSlug !== 'all' ? (
              <LegacyBrandRoutesHandler {...props} />
            ) : (
              <RetailerAccountSelectorHandler>
                <FullNav>
                  <ManageBrandsLayout {...props} />
                </FullNav>
              </RetailerAccountSelectorHandler>
            )
          }}
        />
        <CommonRoute
          path={calendarPaths.index.path}
          render={(props) => {
            return props.match.params.brandSlug !== 'all' ? (
              <LegacyBrandRoutesHandler {...props} />
            ) : (
              <RetailerAccountSelectorHandler>
                <FullNav>
                  <Calendar {...props} />
                </FullNav>
              </RetailerAccountSelectorHandler>
            )
          }}
        />

        <CommonRoute
          path={retailerSettingsPaths.index.path}
          render={(props) => {
            return (
              <RetailerAccountSelectorHandler>
                <FullNav>
                  <RetailerSettingsLayout {...props} />
                </FullNav>
              </RetailerAccountSelectorHandler>
            )
          }}
        />

        <CommonRoute
          path={leadsPaths.import.path}
          render={(props) => {
            return (
              <RetailerAccountSelectorHandler>
                <FullNav>
                  <LeadImport {...props} />
                </FullNav>
              </RetailerAccountSelectorHandler>
            )
          }}
        />
        <CommonRoute
          path={leadsPaths.index.path}
          render={(props) => {
            return (
              <RetailerAccountSelectorHandler>
                <FullNav>
                  <Leads {...props} />
                </FullNav>
              </RetailerAccountSelectorHandler>
            )
          }}
        />
        <CommonRoute
          path={industryContentPaths.index.path}
          render={(props) => {
            return (
              <RetailerAccountSelectorHandler>
                <FullNav>
                  <IndustryContentPage {...props} />
                </FullNav>
              </RetailerAccountSelectorHandler>
            )
          }}
        />

        <CommonRoute
          path={embeddedSearchPaths.index.path}
          render={(props) => {
            return (
              <RetailerAccountSelectorHandler>
                <FullNav>
                  <EmbeddedSearch {...props} />
                </FullNav>
              </RetailerAccountSelectorHandler>
            )
          }}
        />

        <CommonRoute
          path={organicCampaignPaths.details.path}
          render={(props) => {
            return (
              <RetailerAccountSelectorHandler>
                <FullNav>
                  <OrganicCampaignDetailsLayout {...props} />
                </FullNav>
              </RetailerAccountSelectorHandler>
            )
          }}
        />

        <Redirect from={'/retailer'} to={'/retailer/accountSelector'} />
      </Switch>
    </JwtHandler>
  )
}

MainNavRoutes.propTypes = {
  isNewReportingEnabled: PropTypes.bool,
  match: PropTypes.object,
}

export default MainNavRoutes
